import React from "react"
import PropTypes from 'prop-types'
import { Button, Icon, Popup } from "semantic-ui-react"
import { useTextResources } from "../../language"
import { useContext } from "react"
import ReservationContext from "./context"
import { endpoint } from "../../api/http"
export const ReservationMenu = () => {
    const text = useTextResources()
    const {reservation} = useContext(ReservationContext)
    
    const menu = [
        {
            text: "Attachment",
            className: "icon-cloud-computing",
            onclick: ()=>alert(reservation.Id),
            disabled: true
        }, {
            text: "GuestProfile",
            className: "icon-masculine-avatar-user-with-suit",
            url: `${endpoint}CRM/GuestProfile/index/#/profile/${reservation.GuestId}`
        }, {
            text: "FamilyFriendsGroup",
            className: "icon-users-relation",
            disabled: true
        }, {
            text: "Receipt",
            className: "icon-letter-envelope",
            disabled: true
        }, {
            text: "DailyReservation",
            className: "icon-calendarnumber",
            disabled: true
        }, {
            text: "CopyReservation",
            className: "icon-documents-exchange",
            disabled: true
        }, {
            text: "Addons",
            className: "icon-add-contact",
            disabled: true
        }, {
            text: "Discount",
            className: "icon-percentage",
            disabled: true
        }, {
            text: "ReservationCommissions",
            className: "icon-dollar-sign-and-piles-of-coins",
            disabled: true
        }, {
            text: "Email",
            className: "icon-envelope-8",
            disabled: true
        }, {
            text: "CheckIn",
            className: "icon-facebook-placeholder-for-locate-places-on-maps",
            disabled: true
        }, {
            text: "CheckOut",
            className: "icon-exit-2",
            disabled: true
        }, {
            text: "LogRecords",
            className: "icon-verification-of-delivery-list-clipboard-symbol",
            disabled: true
        }, {
            text: "GuestRequests",
            className: "icon-documents-with-a-heart-symbol",
            disabled: true
        }, {
            text: "CreditCard",
            className: "icon-credit-card2",
            disabled: true
        }, {
            text: "Message",
            className: "icon-user-with-message-balloon",
            disabled: true
        }
    ]

    return <Button.Group vertical icon style={{ float: "left" }}>
        {
            menu.map((x, idx) => {
                return <Popup key={idx} position='top right' content={text(x.text)} trigger={
                <Button as={'a'} disabled={x.disabled} href={x.url} icon onClick={x.onclick}>
                    <Icon size="big" className={x.className} />
                </Button>
            } />
            })
        }
    </Button.Group>
}

ReservationMenu.propTypes = {
    reservation: PropTypes.object
}